import { ace_index } from '@axo/shared/data-access/types';

export function setPageNumber(n: number) {
  return (query: ace_index.FindInput) => ({
    ...query,
    PaginationParameters: {
      ...(query.PaginationParameters ?? { PageNumber: 1, PageSize: 20 }),
      PageNumber: n,
    },
  });
}

export function togglePortfolio() {
  return (query: ace_index.FindInput): ace_index.FindInput => ({
    ...setPageNumber(1)(query),
    // Toggle "my portfolio" on/off. Check against 'self' (not undefined) so
    // any other state — All (undefined), Unassigned ('') or a client ID —
    // turns the filter on rather than silently jumping to All.
    AssignmentClientID: query.AssignmentClientID === 'self' ? undefined : 'self',
  });
}
